import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import FormContainer from "../../containers/FormContainer";
import TextBox from "../shared/TextBox";
import TextArea from "../shared/TextArea";
import SubmitButton from "../shared/SubmitButton";
import { useModal } from "../modal/ModalContext";
import { createLeadListPromise, updateLeadListPromise } from "../../services/apiService";
import { getErrorMessage, notifyError } from "../../helpers/apiError";

const LeadListModal = ({ leadList, onSuccess }) => {
  const { t } = useTranslation();
  const { hideModal } = useModal();
  const isEditing = !!leadList;

  const [isLoading, setIsLoading] = useState(false);
  const [formError, setFormError] = useState(null);
  const [form, setForm] = useState({
    name: leadList?.name || "",
    description: leadList?.description || "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const isDisabled = !form.name;

  const handleSubmit = async () => {
    setIsLoading(true);
    setFormError(null);

    const payload = { ...form };
    if (!payload.description) delete payload.description;

    try {
      if (isEditing) {
        await updateLeadListPromise(leadList.id, payload);
        toast.success(t("leadLists.toast.updateSuccess"));
      } else {
        await createLeadListPromise(payload);
        toast.success(t("leadLists.toast.createSuccess"));
      }
      hideModal();
      if (onSuccess) onSuccess();
    } catch (err) {
      const msg = getErrorMessage(err, t("leadLists.toast.error"));
      setFormError(Array.isArray(msg) ? msg : msg);
      notifyError(err, msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-[30px]">
      <FormContainer
        isLoading={isLoading}
        error={typeof formError === "string" || Array.isArray(formError) ? formError : null}
        onSubmit={handleSubmit}
      >
        <TextBox
          label={t("leadLists.name")}
          name="name"
          value={form.name}
          onChange={handleChange}
          placeholder={t("leadLists.name_placeholder")}
          error={formError?.name}
        />
        <TextArea
          name="description"
          value={form.description}
          onChange={handleChange}
          label={t("leadLists.description")}
          rows={3}
        />
        <div className="mt-4">
          <SubmitButton
            customStyle="inline"
            label={isEditing ? t("form.save") : t("leadLists.create")}
            disabled={isDisabled}
            isLoading={isLoading}
          />
        </div>
      </FormContainer>
    </div>
  );
};

export default LeadListModal;
